import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { DrawerSelectEvent } from '@progress/kendo-angular-layout';
import {
    chartColumnStackedIcon,
    awardStarSolidIcon,
    gearIcon,
    homeIcon,
    menuIcon,
    sparklesIcon,
    envelopeLinkIcon,
    dashboardSolidIcon,
    SVGIcon,
} from '@progress/kendo-svg-icons'
import { filter, forkJoin, Observable } from 'rxjs';
import { DrawerItem } from '../../shared/interfaces/drawer-item';
import { Store } from '@ngxs/store';
import { UserViewModel } from '../../shared/interfaces/viewmodels/userviewmodel';
import { AccountActions } from '../../shared/store/action/account.action';
import { AccountState } from '../../shared/store/state/account.state';
import { OptionActions } from '../../shared/store/action/options.action';
import { AuthService } from '../../auth.service';
import { AccountService } from '../../shared/services/account.service';
import { AdminService } from '../../shared/services/admin.service';
import { Permissions } from '../../shared/interfaces/viewmodels/userviewmodel';
declare var CURRENT_USER_ID: number;
declare var CURRENT_USER_LOGINID: string;
declare var CURRENT_USER_DISPLAYNAME: string;
declare var CURRENT_USER_EMAIL: string;
declare var CURRENT_USER: any;
@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrl: './navigation.component.css',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NavigationComponent implements OnInit {

    public $CURRENT_USER_LOGINID: string = CURRENT_USER_LOGINID;
    public $CURRENT_USER_DISPLAYNAME: string = CURRENT_USER_DISPLAYNAME;
    public $CURRENT_USER_ID: number = CURRENT_USER_ID;
    public items: DrawerItem[] = [];
    public menuIcon: SVGIcon = menuIcon;
    public expanded: boolean = false;
    public userDataReady: boolean = false;

    private selectedItem: string = '';

    ngOnInit(): void {
        console.log('Navigation ngOnInit - Getting active account');
        this.authService.getActiveAccount();
        
        console.log('Navigation ngOnInit - Dispatching GetUserByEmail for:', CURRENT_USER_EMAIL);
        this.accservice.getUserByEmail(CURRENT_USER_EMAIL ).subscribe((userres) => {
              
            if (userres) {
                CURRENT_USER = userres;
                CURRENT_USER_ID = userres.id;
                CURRENT_USER_LOGINID = userres.loginID;
                console.log('GetUserByEmail completed successfully, userId:', CURRENT_USER_ID);
                this.loadUser();
            } else {
                console.warn('GetUserByEmail returned invalid user:', userres);
            }
            this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
                if (event.url === '/') {
                    this.selectedItem = '';
                } else {
                    this.selectedItem = event.url;
                }
                this.items = this.drawerItems(this.selectedItem);
            });
        });
    }
  loadUser() {
    // Dispatch all user data actions and wait for the critical ones to complete
    // before allowing child routes to render via userDataReady flag
    const userDetails$ = this.store.dispatch(new AccountActions.GetUserDetails({ id: CURRENT_USER_LOGINID }));
    const subApps$ = this.store.dispatch(new AccountActions.GetAssignSubApplications({ userId: CURRENT_USER_ID, isActive: true }));
    this.store.dispatch(new OptionActions.GetOptions({ id: CURRENT_USER_ID }));

    forkJoin([userDetails$, subApps$]).subscribe({
      next: () => {
        console.log('User data fully loaded - permissions and subapplications ready');
        this.userDataReady = true;
        this.items = this.drawerItems(this.selectedItem); // Rebuild with permissions now available
      },
      error: (err) => {
        console.error('Error loading user data, rendering page anyway:', err);
        this.userDataReady = true; // Still render to avoid a blank page
      }
    });
  }
    constructor(private router: Router, private store: Store, private authService: AuthService, private accservice: AccountService, private adminService: AdminService) {
        
        this.items = this.drawerItems(this.selectedItem);

    }
    public user$!: Observable<UserViewModel>;
    public onItemSelection(ev: DrawerSelectEvent): void {
        this.selectedItem = ev.item.path;
    }

    public drawerItems(selectedItem: string): DrawerItem[] {
        const items: DrawerItem[] = [
            {
                separator: true,
            },
            {
                text: "Home",
                svgIcon: homeIcon,
                path: '',
                selected: selectedItem === '',
            },
            {
                text: "Dashboard",
                svgIcon: dashboardSolidIcon,
                path: '/dashboard',
                selected: selectedItem === '/dashboard',
            },
            {
                text: "Create RTA",
                svgIcon: awardStarSolidIcon,
                path: '/edit',
                selected: selectedItem === '/edit',
            },
            // {
            //     text: "Analytics",
            //     svgIcon: chartColumnStackedIcon,
            //     path: '/analytics',
            //     selected: selectedItem === '/analytics',
            // },
            // {
            //     text: "BitWit",
            //     svgIcon: sparklesIcon,
            //     path: '/bitwit',
            //     selected: selectedItem === '/bitwit',
            // },
            {
                separator: true,
            },
        ];

        if (this.adminService.CheckPermission(Permissions.RTA_ADMIN)) {
            items.push({
                text: "Notifications",
                svgIcon: envelopeLinkIcon,
                path: '/admin',
                selected: selectedItem === '/admin',
            });
        }

        items.push({
            text: "Settings",
            svgIcon: gearIcon,
            path: '/settings',
            selected: selectedItem === '/settings',
        });

        return items;
    }
}
